export default {"src":"/_next/static/media/ticket-white-46x46.63f5f4ff.svg","height":19,"width":15};